// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

function isArray(obj) {
    if (Array.isArray)
        return Array.isArray(obj);
    return (Object.prototype.toString.call(obj) === '[object Array]');
}
/* Filters */

var itero = angular.module('iteroFilters', []);

itero.filter('pdate', ['$filter', 'PUtill', 'DatepickerUtils', function ($filter, PUtill, DatepickerUtils) {
    return function(input, format) {
        if (!input) return "";
        if (typeof input === 'string' || input instanceof String) {
            if (/^20[0-9]{2}-[01][0-9]-[0-3][0-9]$/.test(input))
                input = DatepickerUtils.parseBerlinDate(input);
        }

        if (format === "mediumWithFullTime") format = "MMM dd, yyyy HH:mm:ss";

        let cetMoment = moment(input).tz(PUtill.BerlinTzName);
        let cetMomentDateInBrowserTz = cetMoment.toDate();
        let formatted = $filter('date')(cetMomentDateInBrowserTz, format, cetMoment.format("ZZ"));

        return formatted;
    }
}]);

itero.filter('tz', ['$filter', 'PUtill', 'gettextCatalog', function ($filter, PUtill, gettextCatalog) {
    return function(input) {
        if (!input) return "";
        let timezone = moment(input).tz(PUtill.BerlinTzName).format("z");

        return gettextCatalog.getString(timezone);
    }
}]);

itero.filter('auditlogdatetime', ['$filter', function ($filter) {
    return function(input, format) {
        //datetime iso-8601 regex based on https://www.w3.org/TR/NOTE-datetime
        var regexParts =
        [
            /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))/, //completeRegex
            /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/, //withoutMsRegex
            /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/ //withoutSecRegex
        ];
        var full = regexParts.map(function(x) { return x.source }).join('|');
        var re = new RegExp(full);
        if (re.test(input)) {
            var date = new Date(input);
            return $filter('pdate')(date, format);

        } else {
            return input;
        }
    };
}]);

itero.filter('hyphen', function () {
    return function (input) {
        // return hyphen for null, undefined and empty-string
        return (input === null || input === "" || input === undefined) ? '-' : input;
    };
});

itero.filter('checkmark', function () {
    return function (input) {
        return input ? '\u2713' : '\u2718';
    };
});

itero.filter('keys', function () {
    return function (input) {
        return input && typeof (input) === "object" ? Object.keys(input) : "";
    };
});

itero.filter('range', function () {
    return function (input, total) {
        total = parseInt(total);
        for (let i = 0; i < total; i++)
            input.push(i);
        
        return input;
    };
});

// https://gist.github.com/thomseddon/3511330
itero.filter('bytes', function () {
    return function (bytes, precision) {
        if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
        if (typeof precision === 'undefined') precision = 1;
        var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'],
            number = Math.floor(Math.log(bytes) / Math.log(1024));
        return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
    };
});

var enumFilter = function (value, texts) {
    return texts[value] || value;
};

itero.filter('componentType', ['gettextCatalog', function (gettextCatalog) {
    return function (input) {
        return gettextCatalog.getString(input);
    };
}]);

itero.filter('jaNein', ['gettext', 'gettextCatalog', function (gettext, gettextCatalog) {
    return function (input) {
        return input ? gettextCatalog.getString(gettext("yes")) : gettextCatalog.getString(gettext("no"));
    };
}]);

itero.filter('babel', ['gettext', 'gettextCatalog', function (gettext, gettextCatalog) {
    return function (localizableString, language) {
        language = language || gettextCatalog.currentLanguage;
        if (!localizableString)
            return gettextCatalog.getString(gettext("(Unnamed)"));
        var translation = null;
        if (language)
            translation = localizableString[language];
        if (!translation)
            translation = localizableString._c;
        return translation || gettextCatalog.getString(gettext("(Unnamed)"));
    };
}]);

itero.filter('babelNoDefault', ['gettext', 'gettextCatalog', function (gettext, gettextCatalog) {
    return function (localizableString, language) {
        language = language || gettextCatalog.currentLanguage;
        if (localizableString == null)
            return null;
        var translation = null;
        if (language)
            translation = localizableString[language];
        if (!translation)
            translation = localizableString._c;
        return translation;
    };
}]);

itero.filter('perPeriod', ['gettext', 'gettextCatalog', function (gettext, gettextCatalog) {
    return function (period) {
        if (period == null)
            return "";

        var isPlural = (period.Quantity !== 1); // decimals are generally plural
        var key = "Per" + period.Unit + (isPlural ? "s" : "");
        var templateString = gettextCatalog.getString(key);
        return templateString.replace("{quantity}", period.Quantity);

        // required so the grunt task finds the strings...
        // ReSharper disable JsUnreachableCode
        gettext("PerSecond"); gettext("PerSeconds");
        gettext("PerMinute"); gettext("PerMinutes");
        gettext("PerHour"); gettext("PerHours");
        gettext("PerDay"); gettext("PerDays");
        gettext("PerWeek"); gettext("PerWeeks");
        gettext("PerMonth"); gettext("PerMonths");
        gettext("PerYear"); gettext("PerYears");
        // ReSharper restore JsUnreachableCode
    };
}]);

itero.filter('period', ['gettext', 'gettextCatalog', function (gettext, gettextCatalog) {
    return function (period) {
        if (period == null)
            return gettextCatalog.getString(gettext("None"));

        var suffix = period.Quantity === 1 ? "" : "s";
        var unitString = gettextCatalog.getString(period.Unit + suffix);
        return period.Quantity + " " + unitString;

        // required so the grunt task finds the strings...
        // ReSharper disable JsUnreachableCode
        gettext("Second"); gettext("Seconds");
        gettext("Minute"); gettext("Minutes");
        gettext("Hour"); gettext("Hours");
        gettext("Day"); gettext("Days");
        gettext("Week"); gettext("Weeks");
        gettext("Month"); gettext("Months");
        gettext("Year"); gettext("Years");
        // ReSharper restore JsUnreachableCode
    };
}]);

itero.filter('country', ['gettextCatalog', 'CountryList', function (gettextCatalog, CountryList) {
    var countries = null;
    var store = {};

    function getCountry(code) {
        if (code in store) {
            return store[code];
        }
        if (countries) {
            var len = countries.length;
            for (var i = 0; i < len; i++) {
                var item = countries[i];
                if (item.TwoLetterCode === code) {
                    return store[code] = item;
                }
            }
            store[code] = null;
        }
        return null;
    }

    function getCountryName(code, locale) {
        var country = getCountry(code);
        return country ? country[locale] : null;
    }

    return function (input) {
        if (countries) {
            var countryName = getCountryName(input, gettextCatalog.currentLanguage.toUpperCase());
            return countryName ? countryName : "";
        }

        CountryList.getCountries().then(function (response) {
            countries = response.data;
        },
            function () { });

        return "";
    };
}]);

itero.filter("format", function () {
    return function (input, template) {
        if (input !== null && input !== '') {
            if (template) {
                return template.replace(/\{(\d+)\}/g, function (match, capture) {
                    return input;
                });
            }
            return input;
        }
        return "";
    };
});

itero.filter('idCreated', function () {
    return function (input) {
        return new Date(parseInt(input.slice(0, 8), 16) * 1000);
    };
});

var LANG_CODE_NAME =
{
    "af-ZA": "Afrikaans (Südafrika)",
    "af": "Afrikaans",
    "am-ET": "Amharisch (Äthiopien)",
    "am": "Amharisch",
    "ar-AE": "Arabisch (Vereinigte Arabische Emirate)",
    "ar-BH": "Arabisch (Bahrain)",
    "ar-DZ": "Arabisch (Algerien)",
    "ar-EG": "Arabisch (Ägypten)",
    "ar-IQ": "Arabisch (Irak)",
    "ar-JO": "Arabisch (Jordanien)",
    "ar-KW": "Arabisch (Kuwait)",
    "ar-LB": "Arabisch (Libanon)",
    "ar-LY": "Arabisch (Libysch-Arabische Dschamahirija)",
    "ar-MA": "Arabisch (Marokko)",
    "ar-OM": "Arabisch (Oman)",
    "ar-QA": "Arabisch (Katar)",
    "ar-SA": "Arabisch (Saudi-Arabien)",
    "ar-SY": "Arabisch (Syrien, Arab. Rep.)",
    "ar-TN": "Arabisch (Tunesien)",
    "ar-YE": "Arabisch (Jemen)",
    "ar": "Arabisch",
    "bg-BG": "Bulgarisch (Bulgarien)",
    "bg": "Bulgarisch",
    "bn-BD": "Bengali (Bangladesch)",
    "bn-IN": "Bengali (Indien)",
    "bn": "Bengali",
    "ca-ES": "Katalanisch (Spanien)",
    "ca": "Katalanisch",
    "cs-CZ": "Tschechisch (Tschechische Republik)",
    "cs": "Tschechisch",
    "cy": "Kymrisch",
    "da-DK": "Dänisch (Dänemark)",
    "da": "Dänisch",
    "de-AT": "Deutsch (Österreich)",
    "de-CH": "Deutsch (Schweiz)",
    "de-DE": "Deutsch (Deutschland)",
    "de-LI": "Deutsch (Liechtenstein)",
    "de-LU": "Deutsch (Luxemburg)",
    "de": "Deutsch",
    "el-GR": "Griechisch (Griechenland)",
    "el": "Griechisch",
    "en-AU": "Englisch (Australien)",
    "en-BZ": "Englisch (Belize)",
    "en-CA": "Englisch (Kanada)",
    "en-GB": "Englisch (Vereinigtes Königreich)",
    "en-IE": "Englisch (Irland)",
    "en-IN": "Englisch (Indien)",
    "en-JM": "Englisch (Jamaika)",
    "en-NZ": "Englisch (Neuseeland)",
    "en-PH": "Englisch (Philippinen)",
    "en-SG": "Englisch (Singapur)",
    "en-TT": "Englisch (Trinidad und Tobago)",
    "en-US": "Englisch (Vereinigte Staaten von Amerika)",
    "en-ZA": "Englisch (Südafrika)",
    "en-ZW": "Englisch (Simbabwe)",
    "en": "Englisch",
    "es-AR": "Spanisch (Argentinien)",
    "es-BO": "Spanisch (Bolivien)",
    "es-CL": "Spanisch (Chile)",
    "es-CO": "Spanisch (Kolumbien)",
    "es-CR": "Spanisch (Costa Rica)",
    "es-DO": "Spanisch (Dominikanische Republik)",
    "es-EC": "Spanisch (Ecuador)",
    "es-ES": "Spanisch (Spanien)",
    "es-GT": "Spanisch (Guatemala)",
    "es-HN": "Spanisch (Honduras)",
    "es-MX": "Spanisch (Mexiko)",
    "es-NI": "Spanisch (Nicaragua)",
    "es-PA": "Spanisch (Panama)",
    "es-PE": "Spanisch (Peru)",
    "es-PR": "Spanisch (Puerto Rico)",
    "es-PY": "Spanisch (Paraguay)",
    "es-SV": "Spanisch (El Salvador)",
    "es-US": "Spanisch (Vereinigte Staaten von Amerika)",
    "es-UY": "Spanisch (Uruguay)",
    "es-VE": "Spanisch (Venezuela)",
    "es": "Spanisch",
    "et-EE": "Estnisch (Estland)",
    "et": "Estnisch",
    "eu-ES": "Baskisch (Spanien)",
    "eu": "Baskisch",
    "fa-IR": "Persisch (Iran, Islam. Rep.)",
    "fa": "Persisch",
    "fi-FI": "Finnisch (Finnland)",
    "fi": "Finnisch",
    "fr-BE": "Französisch (Belgien)",
    "fr-CA": "Französisch (Kanada)",
    "fr-CH": "Französisch (Schweiz)",
    "fr-FR": "Französisch (Frankreich)",
    "fr-LU": "Französisch (Luxemburg)",
    "fr-MC": "Französisch (Monaco)",
    "fr": "Französisch",
    "gl-ES": "Galicisch (Spanien)",
    "gl": "Galicisch",
    "gu-IN": "Gujarati-Sprache (Indien)",
    "gu": "Gujarati-Sprache",
    "he-IL": "Hebräisch (Israel)",
    "he": "Hebräisch",
    "hi-IN": "Hindi (Indien)",
    "hi": "Hindi",
    "hr-HR": "Kroatisch  (Kroatien)",
    "hr": "Kroatisch ",
    "hu-HU": "Ungarisch (Ungarn)",
    "hu": "Ungarisch",
    "id-ID": "Bahasa Indonesia (Indonesien)",
    "id": "Bahasa Indonesia",
    "is-IS": "Isländisch (Island)",
    "is": "Isländisch",
    "it-CH": "Italienisch (Schweiz)",
    "it-IT": "Italienisch (Italien)",
    "it": "Italienisch",
    "ja-JP": "Japanisch (Japan)",
    "ja": "Japanisch",
    "kn-IN": "Kannada (Indien)",
    "kn": "Kannada",
    "ko-KR": "Koreanisch (Korea, Rep.)",
    "ko": "Koreanisch",
    "lt-LT": "Litauisch (Litauen)",
    "mt": "Maltesisch",
    "lt": "Litauisch",
    "lv-LV": "Lettisch (Lettland)",
    "lv": "Lettisch",
    "ml-IN": "Malayalam (Indien)",
    "ml": "Malayalam",
    "mr-IN": "Marathi (Indien)",
    "mr": "Marathi",
    "ms-BN": "Malaiisch (Brunei Darussalam)",
    "ms-MY": "Malaiisch (Malaysia)",
    "ms": "Malaiisch",
    "mt-MT": "Maltesisch (Malta)",
    "nl-BE": "Niederländisch (Belgien)",
    "nl-NL": "Niederländisch (Niederlande)",
    "nl": "Niederländisch",
    "no": "Norwegisch",
    "or-IN": "Oriya-Sprache (Indien)",
    "or": "Oriya-Sprache",
    "pl-PL": "Polnisch (Polen)",
    "pl": "Polnisch",
    "pt-BR": "Portugiesisch (Brasilien)",
    "pt-PT": "Portugiesisch (Portugal)",
    "pt": "Portugiesisch",
    "ro-RO": "Rumänisch (Rumänien)",
    "ro": "Rumänisch",
    "ru-RU": "Russisch (Russische Föderation)",
    "ru": "Russisch",
    "sk-SK": "Slowakisch (Slowakei)",
    "sk": "Slowakisch",
    "sl-SI": "Slowenisch (Slowenien)",
    "sl": "Slowenisch",
    "sq-AL": "Albanisch (Albanien)",
    "sq": "Albanisch",
    "sr-Cyrl-BA": "Serbisch  (Bosnien und Herzegowina)",
    "sr-Cyrl-ME": "Serbisch  (Montenegro)",
    "sr-Cyrl-RS": "Serbisch  (Serbien)",
    "sr-Cyrl": "Serbisch  (Kyrillisch)",
    "sr-Latn-BA": "Serbisch  (Bosnien und Herzegowina)",
    "sr-Latn-ME": "Serbisch  (Montenegro)",
    "sr-Latn-RS": "Serbisch  (Serbien)",
    "sr-Latn": "Serbisch  (Lateinisch)",
    "sr": "Serbisch ",
    "sv-FI": "Schwedisch (Finnland)",
    "sv-SE": "Schwedisch (Schweden)",
    "sv": "Schwedisch",
    "sw-KE": "Swahili (Kenia)",
    "sw": "Swahili",
    "ta-IN": "Tamil (Indien)",
    "ta": "Tamil",
    "te-IN": "Telugu-Sprache (Indien)",
    "te": "Telugu-Sprache",
    "th-TH": "Thailändisch (Thailand)",
    "th": "Thailändisch",
    "tr-TR": "Türkisch (Türkei)",
    "tr": "Türkisch",
    "uk-UA": "Ukrainisch (Ukraine)",
    "uk": "Ukrainisch",
    "ur-PK": "Urdu (Pakistan)",
    "ur": "Urdu",
    "vi-VN": "Vietnamesisch (Vietnam)",
    "vi": "Vietnamesisch",
    "zh-CN": "Chinesisch (China)",
    "zh-Hans": "Chinesisch (Vereinfacht)",
    "zh-Hant": "Chinesisch (Traditionell)",
    "zh-HK": "Chinesisch (Hong Kong)",
    "zh-TW": "Chinesisch (Taiwan)",
    "zh": "Chinesisch",
    "zu-ZA": "Zulu-Sprache (Südafrika)",
    "zu": "Zulu-Sprache"
};

itero.filter('lcodeName', ['gettext', 'gettextCatalog', 'LocaleList', function (gettext, gettextCatalog, LocaleList) {
    let localeList = [];
    
    function buildLocaleCodeName(lcode) {
        if (isArray(lcode)) {
            var outStr = gettextCatalog.getString(gettext("for")) + " ";
            var comma = " ";
            lcode.forEach(function (lc) {
                if (lc && lc != "_c") {
                    outStr = outStr + comma + LANG_CODE_NAME[lc];
                    comma = ", ";
                }
            });
            return outStr || "(error)";
        } else if (lcode === "_c") {
            return "Default";
        } else {
            if (localeList.length !== 0 && lcode) {
                let localeTitle = localeList.find(function (locale) {
                    return locale.OriginalTag === lcode;
                });
                if(localeTitle) {
                    if (gettextCatalog.currentLanguage.toUpperCase() === 'DE') {
                        return localeTitle.GermanName + " - " + lcode;
                    }
                    return localeTitle.EnglishName + " - " + lcode;
                }
            }
        }
    }

    function SetLocaleList() {
        //this query cached according LocaleList service
        LocaleList.getLocales().then(function (response) {
                localeList = response.data;
            },
            function () {});
    }

    SetLocaleList();
    return function (lcode) {
      return  buildLocaleCodeName(lcode);
    }
}]);

itero.filter('getdays', ['gettext', 'gettextCatalog', function (gettext, gettextCatalog) {
    return function (number) {
        if (number === 1)
            return number + " " + gettextCatalog.getString(gettext("Day"));
        else
            return number + " " + gettextCatalog.getString(gettext("Days"));
    };
}]);

itero.filter('paymenttype', function () {
    return function (type, psp) {
        if (type == null) return psp;
        else return type;
    };
});

itero.filter('paymentProvider', ['gettext', 'gettextCatalog', function (gettext, gettextCatalog) {
    return function (obj) {
        var provider = obj.PaymentProvider;
        var role = obj.PaymentProviderRole;

        var result;
        if (provider === "None")
            provider = gettext("Manual");

        var relevantRoles = [gettext("CreditCard"), gettext("Debit"), gettext("BlackLabel"),
            gettext("Betalingsservice"), gettext("iDEAL"), gettext("Autogiro"), gettext("Avtalegiro"), gettext("ApplePay"),
            gettext("AfterPay"), gettext("PayPal"), gettext("VippsMobilePay"), gettext("TWINT")];
        if (relevantRoles.indexOf(role) >= 0)
            result = gettextCatalog.getString(role) + " via " + gettextCatalog.getString(provider);
        else
            result = gettextCatalog.getString(provider);

        return result;

        // required so the grunt task finds the strings...
        // ReSharper disable JsUnreachableCode
        gettext("CreditCard");
        gettext("Debit");
        gettext("BlackLabel");
        gettext("PayPal");
        gettext("FakeProvider");
        gettext("InvoicePayment");
        gettext("PayOne");
        gettext("Betalingsservice");
        gettext("iDEAL");
        gettext("Autogiro");
        gettext("Avtalegiro");
        gettext("ApplePay");
        gettext("AfterPay");
        gettext("PayPal");
        gettext("VippsMobilePay");
        gettext("TWINT");
        // ReSharper restore JsUnreachableCode
    };
}]);

itero.filter('kpiDelta', function () {
    return function (val) {
        if (isNaN(val)) return '';

        var res = Math.abs(val).toFixed(0) + '%';
        if (val === 0) return res;
        return val < 0 ? '-' + res : '+' + res;
    };
});

itero.filter('planVariantName', ['gettext', 'periodFilter', 'perPeriodFilter', function (gettext, periodFilter, perPeriodFilter) {
    return function (planVariant, productInfo) {
        if (planVariant.InternalName)
            return planVariant.InternalName;

        var plan = productInfo.PlanById(planVariant.PlanId);
        var planGroup = productInfo.PlanGroupById(plan.PlanGroupId);
        var recurringFeeString = planVariant.RecurringFee + " " + planGroup.Currency + " " + perPeriodFilter(planVariant.FeePeriod);
        var result = recurringFeeString + " " + gettext("at least") + " " + periodFilter(planVariant.ContractPeriod);
        return result;
    };
}]);

itero.filter('componentName', ['babelFilter', function (babelFilter) {
    return function (component) {
        let name = babelFilter(component.Name);
        
        if(component.ExternalId)
            name += ` (${component.ExternalId})`;
        
        return name;
    };
}]);


itero.filter('ifEmpty', function () {
    return function(input, defaultValue) {
        if (angular.isUndefined(input) || input === null || input === '') {
            return defaultValue;
        }

        return input;
    };
});

itero.filter('dateRange', ['gettext', 'gettextCatalog', 'dateFilter', function (gettext, gettextCatalog, dateFilter) {
    return function (input) {
        if (input == null || (input.Start == null && input.InclusiveEnd == null))
            return null;
        return dateFilter(input.Start || "") + " " + gettextCatalog.getString(gettext("to")) + " " + dateFilter(input.InclusiveEnd || "");
    };
}]);

itero.filter('formattedList', function () {
    return function (input) {
        return input.join(' ');
    };
});

itero.filter('array', function () {
    return function (input) {
        return isArray(input) ? input.join(', ') : input;
    }
});

itero.filter('maskExternal', function () {
    return function (input, max, start, end) {
        var _max = max || 20;
        var _start = start || 10;
        var _end = end || 5;

        if (input && input.length >= _max)
            return input.substring(0, _start) + '...' + input.substring(input.length - _end);

        return input;
    };
});

itero.filter('kilobytes', function () {
    return function (bytes) {
        if (bytes && typeof bytes === 'number' || !isNaN(bytes)) {
            if (bytes === 0 || bytes === '0')
                return '-';
            
            return (bytes / 1024).toFixed(0) + ' kB';
        }
        return bytes;
    };
});

itero.filter('dynamicFilter', function ($filter) {
    return function (value, filter) {
        if (!filter) return value;

        var args = filter.split(':');
        var filterName = args.splice(0, 1, value);
        return $filter(filterName).apply(null, args);
    };
});
